import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../../UI/form/MyButton'
import MyModal from '../../../../../UI/modal/MyModal'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SupplyOrderItemForm from './SupplyOrderItemForm';

const SupplyOrderItemButton = ({ supplyOrderItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                supplyOrderItem ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={supplyOrderItem ? 'Редагувати позицію в заявці' : 'Додати позицію в заявці'}
            disableClickOutside={true}
            content={
                <SupplyOrderItemForm
                    supplyOrderItemBd={supplyOrderItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SupplyOrderItemButton